
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#collaborationFilled_svg__clip0_121_177)"}},[_c('path',{attrs:{"d":"M17.974 12.748a.299.299 0 01-.172-.299 7.492 7.492 0 00-3.318-6.947.315.315 0 01-.137-.31 4.067 4.067 0 00-3.914-4.69 4.07 4.07 0 00-4.115 4.69.317.317 0 01-.137.312 7.491 7.491 0 00-3.314 6.945.297.297 0 01-.172.299 4.064 4.064 0 00-2.362 3.69A4.053 4.053 0 004.376 20.5a4.054 4.054 0 003.207-1.543.312.312 0 01.344-.102 7.49 7.49 0 002.406.395 7.49 7.49 0 002.406-.395.31.31 0 01.344.102A4.054 4.054 0 0016.29 20.5a4.053 4.053 0 004.043-4.063 4.065 4.065 0 00-2.36-3.689zm-1.4-.66a.302.302 0 01-.301.287h-.002a4.062 4.062 0 00-3.953 4.998.312.312 0 01-.215.373 6.237 6.237 0 01-1.768.254 6.237 6.237 0 01-1.767-.254.312.312 0 01-.215-.373A4.062 4.062 0 004.4 12.375h-.002a.3.3 0 01-.301-.287 6.196 6.196 0 01.48-2.77 6.223 6.223 0 011.96-2.529.312.312 0 01.447.07 4.062 4.062 0 006.703-.002.312.312 0 01.447-.07 6.223 6.223 0 012.44 5.3z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"collaborationFilled_svg__clip0_121_177"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"currentColor","transform":"translate(.333 .5)"}})])])])
          )
        }
      }
    